"use strict";function toConversation$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.toConversation$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.chat.toConversation";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.6.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.6.0"},_a)),exports.toConversation$=toConversation$,exports.default=toConversation$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/chat/toConversation.js
// module id = 922
// module chunks = 106